var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useState } from "react";
import Logo from "../../assets/img/logo.svg";
import { Link, useHistory } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import NotificationContext from "../../context/NotificationContext";
import { emitToastNotification } from "../../utils";
import { NotificationType, Redirect } from "@domainpage/shared/src";
import { useLocation } from "react-router-dom";
import ModernPage from "../../layout/ModernPage";
var ForgotPassword = function () {
    var auth = useContext(AuthContext).state;
    var _a = useContext(NotificationContext), notification = _a.state, dispatch = _a.dispatch;
    var _b = useState(""), email = _b[0], setEmail = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var history = useHistory();
    var useQuery = function () {
        return new URLSearchParams(useLocation().search);
    };
    var resetFormFields = function () {
        setEmail("");
    };
    var query = useQuery();
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, res, notification;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!email) {
                        resetFormFields();
                        return [2 /*return*/, emitToastNotification(dispatch, {
                                title: "Email Required",
                                message: "Please provide your email address",
                                type: NotificationType.ERROR,
                            })];
                    }
                    payload = {
                        email: email,
                    };
                    return [4 /*yield*/, fetch("/api/emails/reset-password", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(payload),
                        })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    notification = _a.sent();
                    emitToastNotification(dispatch, notification);
                    if (notification.type === NotificationType.SUCCESS) {
                        history.push(Redirect.LOGIN);
                    }
                    resetFormFields();
                    return [2 /*return*/];
            }
        });
    }); };
    return !loading ? (_jsxs(ModernPage, { children: [_jsxs("div", __assign({ className: "sm:mx-auto sm:w-full sm:max-w-md" }, { children: [_jsx("img", { className: "object-center m-auto lg:block h-12 w-auto", src: Logo, alt: "Sendpoint logo" }, void 0), _jsx("h2", __assign({ className: "mt-0 text-center text-xl leading-9 font-extrabold text-gray-900" }, { children: "Forgot Password" }), void 0)] }), void 0), _jsx("div", __assign({ className: "mt-8 sm:mx-auto sm:w-full sm:max-w-md" }, { children: _jsx("div", __assign({ className: "bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" }, { children: _jsxs("form", __assign({ onSubmit: function (e) { return handleSubmit(e); } }, { children: [_jsxs("div", __assign({ className: "mt-6" }, { children: [_jsx("label", __assign({ htmlFor: "password", className: "block text-sm font-medium leading-5 text-gray-700" }, { children: "Email address" }), void 0), _jsx("div", __assign({ className: "mt-1 rounded-md shadow-sm" }, { children: _jsx("input", { id: "email", type: "email", name: "email", value: email, onChange: function (e) { return setEmail(e.target.value); }, required: true, className: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" }, void 0) }), void 0)] }), void 0), _jsx("div", __assign({ className: "mt-6 flex items-center justify-between" }, { children: _jsx("div", __assign({ className: "text-sm leading-5" }, { children: _jsx(Link, __assign({ to: "/register", className: "font-bold text-gray-600 hover:text-gray-500 focus:outline-none focus:underline transition ease-in-out duration-150" }, { children: "Need an account? Register instead." }), void 0) }), void 0) }), void 0), _jsx("div", __assign({ className: "mt-6" }, { children: _jsx("span", __assign({ className: "block w-full rounded-md shadow-sm" }, { children: _jsx("button", __assign({ type: "submit", className: "w-full flex justify-center py-2 px-5 border border-transparent text-sm font-medium rounded-lg text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-500 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out" }, { children: "Forgot Password" }), void 0) }), void 0) }), void 0)] }), void 0) }), void 0) }), void 0)] }, void 0)) : null;
};
export default ForgotPassword;
